<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Trash Admin</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Restore</th>
                        </tr>
                        <tr v-for="(admin_master,i) in trash_admin_master.data" :key="admin_master.id">
                            <td>{{ i+1 }}</td>
                            <td> {{ admin_master.name}} </td>
                            <td>{{ admin_master.email }}</td>
                            <td>
                                <a href="#" @click="restore(admin_master.id)" ><i class="fas fa-recycle green"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="trash_admin_master" @pagination-change-page="loadAndSearchTrashAdmin" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchTrashAdmin(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                search:'',
                trash_admin_master:{}
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchTrashAdmin();
            })
            Fire.$on('AfterChangeAdmin',()=>{
                this.loadAndSearchTrashAdmin();
            });
        },
        mounted(){
            this.loadAndSearchTrashAdmin();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            restore(id){
                Swal.fire({
                    title: 'Are you sure Restore It?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, do it!'
                    }).then((result) => {
                        if(result.value){
                            axios.get('restoreAdmin/'+id).then(()=>{
                                Fire.$emit('AfterChangeAdmin');
                                this.toast.$emit('SwalSuccess',"Success!", "Admin Restore Successfully");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Admin Is Already In Use");
                            })
                        }
                    })
            },
            loadAndSearchTrashAdmin(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchTrashAdmin?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.trash_admin_master = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
